export default __webpack_public_path__ + "static/social-experian-generic-56ffb4bbfbaa8fdadb9b232dc73a5165.svg";